import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
export const GENERATED_LIMIT = 10;
class GeneratedFileList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            expanded: false,
        };
        this.handleToggleExpanded = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState((prevState) => {
                return {
                    expanded: !prevState.expanded,
                };
            });
        };
    }
    render() {
        const { options, t } = this.props;
        const areFilesPresent = options && options.files && Array.isArray(options.files);
        const files = areFilesPresent ? options.files : options && Array.isArray(options) ? options : [];
        const fileList = (this.state.expanded ? files : files.slice(0, GENERATED_LIMIT)).join(', ');
        const hideExpandButton = files.length < GENERATED_LIMIT || this.state.expanded;
        return (_jsxs(_Fragment, { children: [t('generatedFilesMessage'), "(", fileList, hideExpandButton ? null : (_jsx("a", { className: "ml-1", href: "#", onClick: this.handleToggleExpanded, children: t('moreGenerated', {
                        count: files.length - GENERATED_LIMIT,
                    }) })), ")."] }));
    }
}
export default withTranslation()(GeneratedFileList);
